<template>
  <div id="shell" >
    <div class="top-search" :style="first?'':'margin-top:30vh'">
      <div class="title">查询UDI</div>
      <div class="input">
        <a-input placeholder="请输入产品码" v-model="searchInfo" ></a-input>
        <a-button type="primary" icon="search" @click="onChange"></a-button>
      </div>
    </div>
    <div v-if="loading" style="padding-top: 20vh;font-size: 30px;font-weight: 700;color: #ffffff">
      正在查询...
    </div>
    <div v-if="timeline.length == 0 && first && !loading" style="padding-top: 20vh;font-size: 30px;font-weight: 700;color: #ffffff">
      查询结果:暂无内容
    </div>
    <div v-if="timeline.length > 0 && !loading " style="flex-grow: 1;overflow: auto">
      <div class="bottom-base">
        <a-row>
          <a-col :span="12">产品名称 : {{baseinfo.scannerCodeMaterialVO.productName}}</a-col>
          <a-col :span="12">DI : {{baseinfo.scannerCodeMaterialVO.identificationCode}}</a-col>
          <a-col :span="12">规格 : {{baseinfo.scannerCodeMaterialVO.specificationModel}}</a-col>
          <a-col :span="12">批次号 : {{baseinfo.scannerCodeMaterialVO.batchNumber}}</a-col>
          <a-col :span="12">创建人 : {{baseinfo.materInfo.createBy?baseinfo.materInfo.createBy:'--'}}</a-col>
          <a-col :span="12">创建时间 : {{baseinfo.materInfo.createTime?baseinfo.materInfo.createTime:'--'}}</a-col>
          <a-col :span="12">更新人 : {{baseinfo.materInfo.updateBy?baseinfo.materInfo.updateBy:'--'}}</a-col>
          <a-col :span="12">更新时间 : {{baseinfo.materInfo.updateTime?baseinfo.materInfo.updateTime:'--'}}</a-col>
        </a-row>
      </div>
      <div class="bottom-result" >
        <a-timeline>
          <a-timeline-item v-for="(item,index) in timeline" :key="index"">
            <a-row>
              时间：{{item.operateTime}}
            </a-row>
            <a-row>
              操作人：{{item.operatePerson}}
            </a-row>
            <a-row>
              操作类型：{{item.operateType}}
            </a-row>
            <a-row>
              操作详情：{{item.operateDetails}}
            </a-row>
            <!--          <a-row>-->
            <!--            产品信息：{{item.operateDetails}}-->
            <!--          </a-row>-->
          </a-timeline-item>
        </a-timeline>
      </div>
    </div >

  </div>
</template>

<script >
import { getStreamingRecords } from '@api/api'

export default {
  name: "IndexChart",
  data:()=>{
    return {
      searchInfo:'',
      timeline:[],
      baseinfo:{},
      first:false,
      loading:false,
    }
  },
  methods:{
    onChange(searchInfo){
      this.first = true
      this.loading = true
      getStreamingRecords({code:this.searchInfo}).then(res=>{
        this.loading = false
        if(res.result == null){
          this.timeline = []
        }else{
          this.timeline = res.result.streamingRecords
          this.baseinfo = res.result.productInfo
        }
      }).catch(err=>{
        this.loading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
#shell {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#shell>div {


}
.top-search{
  width: 800px;
  height: auto;
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title{
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    margin-bottom: 20px;
  };
  .input{
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    input{
      border-radius: 30px;
      line-height: 50px;
      height: 50px;
      flex-grow: 1;
    }
    button{
      line-height: 30px;
      height: 35px;
      width: 60px;
      border-radius: 30px;
      i{
       line-height: 25px;
      }
      position: absolute;
      right: 8px;
    }
  }
}
.bottom-base{
  width: 600px;
  margin-top: 10px;
  background-color: #ffffff;
  padding: 10px;
  .ant-col{
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

.bottom-result{
  width: 600px;
  flex-grow: 1;
  margin-top: 10px;
  padding: 10px;
  padding-top: 20px;
  background-color: #ffffff;

}
</style>